module.exports = __webpack_public_path__ + "static/img/weather_005.ed8e7a03.svg";